import useScript from '@/hooks/useScript';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

window.L = L;

// Dynamically import leaflet-draw after L is on window
import('leaflet-draw').then(() => {
  import('leaflet-draw/dist/leaflet.draw.css');
});

function ScriptsLoader() {
  useScript('https://palmetto-dma-pwa-lib.s3.amazonaws.com/sql-allow-memory-growth.js');
  useScript('https://palmetto-dma-pwa-lib.s3.amazonaws.com/Leaflet.VectorGrid.bundled.min.js');
  return null;
}

export default ScriptsLoader;
